import(/* webpackMode: "eager" */ "/app/apps/web/src/app/[locale]/(admin)/sidebar.tsx");
import(/* webpackMode: "eager" */ "/app/apps/web/src/components/user.tsx");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/app/packages/ui/src/button.tsx")